module.exports = __webpack_public_path__ + "img/ch16_25_小满检查.265abdb8.jpg";